"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OFFSET = exports.MIN_WINDOW_SIZE = exports.MAX_SHOWCASE_WIDTH = void 0;
var tslib_1 = require("tslib");
var jsx_runtime_1 = require("react/jsx-runtime");
var React = tslib_1.__importStar(require("react"));
var houston_styles_1 = tslib_1.__importStar(require("@eduzz/houston-styles"));
var ModalBase_1 = tslib_1.__importDefault(require("../Modal/__utils/ModalBase"));
var Overlay_1 = tslib_1.__importDefault(require("../Overlay"));
var Portal_1 = tslib_1.__importDefault(require("../Portal"));
var nestedComponent_1 = tslib_1.__importDefault(require("../utils/nestedComponent"));
var Content_1 = tslib_1.__importDefault(require("./Content"));
var context_1 = tslib_1.__importDefault(require("./context"));
var Footer_1 = tslib_1.__importDefault(require("./Footer"));
var Image_1 = tslib_1.__importDefault(require("./Image"));
var Step_1 = tslib_1.__importDefault(require("./Step"));
var Text_1 = tslib_1.__importDefault(require("./Text"));
var Title_1 = tslib_1.__importDefault(require("./Title"));
var useResize_1 = tslib_1.__importDefault(require("./useResize"));
exports.MAX_SHOWCASE_WIDTH = 400;
exports.MIN_WINDOW_SIZE = 440;
exports.OFFSET = 40;
var Showcase = function (_a) {
    var open = _a.open, currentStep = _a.currentStep, children = _a.children, className = _a.className, widthSize = _a.widthSize, controlDots = _a.controlDots, rest = tslib_1.__rest(_a, ["open", "currentStep", "children", "className", "widthSize", "controlDots"]);
    if (!open) {
        return null;
    }
    var _b = tslib_1.__read(children, 1), showcaseContent = _b[0];
    var showcaseSteps = showcaseContent.props.children;
    return ((0, jsx_runtime_1.jsx)(Portal_1.default, tslib_1.__assign({ target: 'houston-showcase' }, { children: (0, jsx_runtime_1.jsx)(Overlay_1.default, tslib_1.__assign({ visible: true }, { children: (0, jsx_runtime_1.jsx)(ModalBase_1.default, tslib_1.__assign({ className: className }, rest, { children: (0, jsx_runtime_1.jsx)(context_1.default, tslib_1.__assign({ value: {
                        currentStep: currentStep,
                        totalSteps: showcaseSteps.length,
                        stepSize: widthSize < exports.MIN_WINDOW_SIZE ? widthSize - exports.OFFSET : exports.MAX_SHOWCASE_WIDTH,
                        controlDots: controlDots === undefined ? true : controlDots
                    } }, { children: children })) })) })) })));
};
var StyledShowcase = (0, houston_styles_1.default)(Showcase, { label: 'hst-showcase' })(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var theme = _a.theme, widthSize = _a.widthSize;
    return (0, houston_styles_1.css)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n      width: ", "rem;\n      max-width: ", "rem;\n      max-height: 90vw;\n      overflow-x: hidden;\n      box-shadow: none;\n    "], ["\n      width: ", "rem;\n      max-width: ", "rem;\n      max-height: 90vw;\n      overflow-x: hidden;\n      box-shadow: none;\n    "])), theme.pxToRem(widthSize - exports.OFFSET), theme.pxToRem(exports.MAX_SHOWCASE_WIDTH));
});
var ShowcaseWrapper = function (_a) {
    var children = _a.children, rest = tslib_1.__rest(_a, ["children"]);
    var width = (0, useResize_1.default)().width;
    return ((0, jsx_runtime_1.jsx)(StyledShowcase, tslib_1.__assign({}, rest, { widthSize: width }, { children: children })));
};
exports.default = (0, nestedComponent_1.default)(React.memo(ShowcaseWrapper), {
    Title: Title_1.default,
    Step: Step_1.default,
    Content: Content_1.default,
    Image: Image_1.default,
    Text: Text_1.default,
    Footer: Footer_1.default
});
var templateObject_1, templateObject_2;
